export default {
  containerWidth: '600px',
  alertWidth: '560px',
  bodyTextWidth: '528px',
  inputFieldWidth: '344px',
  inputFieldLongWidth: '528px'
}
